<template>
    <div class="final-pr-container">
        <div v-if="isCompleted" class="final-pr-header">
            <div class="pr-final-header-left">
                <img :src="require('@/assets/icons/pr-completed.svg')" />
                <div class="completed-msg">
                    <h2 class="title">Article Generated</h2>
                </div>
            </div>
            <div class="pr-final-header-right">
                <div v-if="false" class="pr-final-btn-wrapper">
                    <img :src="require('@/assets/icons/share.svg')"></img>
                    <p class="home-btn-text">Share</p>
                </div>

                <button class="pr-final-btn-wrapper" @click="goToHome()">
                    <img :src="require('@/assets/icons/home.svg')" alt="">
                    <p class="home-btn-text">Go to Dashboard</p>
                </button>

                <button class="pr-final-btn-wrapper" :disabled="downloadLoader" @click="downloadFinalArticle()">

                    <div class="download-wrapper">
                        <Svg :src="require('@/assets/icons/download.svg')" fill="white"></Svg>
                        <p>Download</p>
                        <v-progress-circular v-if="downloadLoader" indeterminate :size="18"
                            :width="2"></v-progress-circular>
                    </div>

                </button>
            </div>

        </div>

        <div v-else class="completed-doc-header-left">
            <div class="doc-name-editor-wrapper">
                <span class="doc-title">{{ docName }}</span>
                <RenamePopup v-if="isEditing" :docName="docName" :isEditing="isEditing"
                    :id="$route.params.articleId" flowType="article"
                    @update-isEdit="isEditing = $event" @updated-prTitle="docName = $event" />
                <button class="edit-btn" @click="isEditing = true">
                    <img :src="require('@/assets/icons/edit.svg')" />
                </button>   
            </div>
        </div>

        <div class="final-article-wrapper">
            <div class="final-pr-left">
                <div class="body">
                    <div class="body-wrapper">
                        <div class="body-content" v-html="renderedArticle">
                        </div>
                    </div>

                </div>
            </div>
            <div class="final-pr-right">
                <div class="right-container">
                    <div class="meta-data-wrapper">
                        <div class="meta-data-header">
                            <p class="header-title">Source-code Campaigning - generate assets, content and campaigns at
                                scale</p>
                        </div>
                        <div class="assets-container">
                            <div class="assets-wrapper" @click="openGeneratePopup('Social Media Campaign')">
                                <div class="asset-left">
                                    <img :src="require('@/assets/icons/social-media-icon.svg')" />
                                    <p class="asset-type">Generate Social Media Campaign</p>
                                </div>
                                <img :src="require('@/assets/icons/create-icon.svg')" width="18px"/>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
    <GeneratePopup v-if="generatePopup" v-model="generatePopup" :flowType="selectedFlowType" :documentData=documentData>
    </GeneratePopup>

</template>

<script>
import { downloadPr } from '@/helper/downloadPr';
import GeneratePopup from '@/components/GeneratePopup.vue';
import { marked } from 'marked';
import RenamePopup from '@/components/RenamePopup.vue';

export default {
    components: {
        GeneratePopup, RenamePopup
    },

    data() {
        return {
            downloadLoader: false,
            articleContent: {},
            generatePopup: false,
            selectedFlowType: '',
            documentData: null,
            articleTitle: null,
            docName: null,
            isEditing: false
        }
    },
    props: {
        article: {
            type: Object
        },
        isCompleted: {
            type: Boolean
        },
        documenName: {
            type: String
        }
    },
    computed: {
        renderedArticle() {
            if (!this.articleContent.baseArticle) {
                return '';
            }
            return this.articleContent.baseArticle;
        }
    },
    methods: {
        goToHome() {
            this.$router.push({ name: 'ArticleHome' });
        },
        openGeneratePopup(type) {
            this.selectedFlowType = type
            this.generatePopup = true
        },
        async downloadFinalArticle() {
            this.downloadLoader = true;

            const payload = {
                articleId: this.$route.params.articleId,
                flowType: "ARTICLE"
            }
            await downloadPr(payload, this.articleTitle);
            this.downloadLoader = false;
        },
    },
    mounted() {
        this.articleContent = this.article;
        this.docName = this.documenName
        const match = this.articleContent.baseArticle.match(/<h1[^>]*>(.*?)<\/h1>/i);
        this.articleTitle = match ? match[1].trim() : '';
        this.documentData = {
            documentId: this.$route.params.articleId,
            documentName: this.articleTitle,
            documentType: 'ARTICLE',
            imageUrl: require('@/assets/icons/article-grey-icon.svg')
        }

    }

}

</script>

<style scoped>
.final-pr-container {
    display: flex;
    gap: 2rem;
    width: 100%;
    padding: 2rem 9rem 2rem 13rem;
    flex-direction: column;

}

.completed-doc-header-left {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
}

.doc-name-editor-wrapper {
    display: flex;
    align-items: center;
    gap: 16px;
    color: white;
}

.doc-title {
    font-size: 24px;
}

.doc-name-editor-wrapper .edit-btn {
    display: flex;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
    align-items: center;
    cursor: pointer;
    background: none;
}

.edit-title-input {
    width: 200px;
    align-items: center;
}

.edit-btn {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 50%;
    border: 1px solid #A3A3A3;
    background: white;
}

.final-article-wrapper {
    display: flex;
    flex-direction: row;
    gap: 2.5rem;
}

.final-pr-left {
    flex: 2;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.final-pr-right {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 1rem;
}

.final-pr-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.5em;
    background: var(--primary-gradient-bar-with-black);
    padding: 1rem 1.5rem;
    border-radius: 8px;
    color: var(--secondary-font-color);
    justify-content: space-between;
}

.pr-final-header-left {
    display: flex;
    gap: 1rem;
}

.pr-final-header-right {
    display: flex;
    flex-direction: row;
    gap: 1rem;
}

.completed-msg {
    display: flex;
    flex-direction: column;
    gap: 4px;
    color: white;
}

.pr-final-btn-wrapper {
    display: flex;
    justify-content: center;
    background: #FFFFFF1F;
    gap: 4px;
    padding: 0.5rem 1rem;
    border: 1px solid #FFFFFF33;
    align-items: center;
    border-radius: 8px;
    font-size: var(--normal-font-size);
}

.download-wrapper {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
}

.body {
    background-color: var(--secondary-font-color);
    border-radius: 8px;
    padding: 1rem;
    overflow: hidden;
}

.body-wrapper {
    height: 100%;
    overflow: auto;
    scrollbar-width: thin;

}

.body-content {
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 6px;
    padding: 1rem;
    color: black;
    gap: 1rem;
}

.title {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
}

.right-container {
    display: flex;
    flex-direction: row;
    gap: 2rem;
}

.meta-data-wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    background-color: #ffffff12;
    color: var(--secondary-font-color);
    border-radius: 12px;
}

.meta-data-header {
    padding: 1rem 1.5rem;
    border-bottom: 2px solid #FFFFFF12
}

.assets-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0rem 1.5rem 1rem;
}

.assets-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #FFFFFF13;
    border-radius: 8px;
    padding: 0.5rem 1rem;
}

.asset-left {
    display: flex;
    flex-direction: row;
    gap: 1rem;
}
</style>